document.addEventListener('DOMContentLoaded', function() {
	const productHandle = document.querySelector('product-info').getAttribute('data-handle'); // Liquid variable for the product handle
	const storeRecentlyViewedProduct = (handle) => {
		const key = 'recentlyViewed';
		const maxHandles = 50; // Set a high threshold for cleanup

		// Retrieve the current list from localStorage
		let storedHandles = JSON.parse(localStorage.getItem(key)) || [];

		// Remove the handle if it already exists to avoid duplicates
		storedHandles = storedHandles.filter(storedHandle => storedHandle !== handle);

		// Add the new handle to the beginning of the list
		storedHandles.unshift(handle);

		// Perform cleanup: Remove the oldest entries beyond the threshold
		if (storedHandles.length > maxHandles) {
			storedHandles = storedHandles.slice(0, maxHandles);
		}

		// Save the updated list back to localStorage
		localStorage.setItem(key, JSON.stringify(storedHandles));
	}

	storeRecentlyViewedProduct(productHandle);

	const periodicCleanup = (key, days) => {
		const lastCleanupKey = `${key}-lastCleanup`;
		const now = Date.now();
	
		// Retrieve the timestamp of the last cleanup
		const lastCleanup = parseInt(localStorage.getItem(lastCleanupKey), 10) || 0;
	
		// If it’s been more than the specified number of days, clear old data
		if (now - lastCleanup > days * 24 * 60 * 60 * 1000) {
			console.log('Performing periodic cleanup...');
			localStorage.removeItem(key);
			localStorage.setItem(lastCleanupKey, now.toString());
		}
	}
	
	// Run the cleanup on page load
	periodicCleanup('recentlyViewedProducts', 30); // Cleanup every 30 days
});